export const MATCH_STANDALONE = '(display-mode: standalone)'
